import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
	const previewSlider = document.getElementById("slider-preview");
	const detailSlider = document.getElementById("slider-detail");

	let preview, detail;

	if (previewSlider && window.innerWidth >= 992) {
		preview = new Splide(previewSlider, {
			type: "loop",
			perPage: 3,
			perMove: 1,
			gap: 24,
			focus: 0,
			autoWidth: false,
			updateOnMove: true,
			rewind: true,
			arrows: false,
			pagination: false,
			isNavigation: true,
			breakpoints: {
				1200: {
					perPage: 2,
				},
			},
		}).mount();
	}

	if (detailSlider) {
		const detailNav = document.querySelector(".detail-nav");

		detail = new Splide(detailSlider, {
			type: "loop",
			perPage: 1,
			perMove: 1,
			focus: "center",
			arrows: false,
			pagination: false,
		}).mount();

		// Ajouter les événements sur les flèches personnalisées
		if (detailNav) {
			const prevArrow = detailNav.querySelector(".arrow-prev");
			const nextArrow = detailNav.querySelector(".arrow-next");
			const slideCounter = detailNav.querySelector(".slide-count");

			if (prevArrow) {
				prevArrow.addEventListener("click", () => {
					detail.go("<");
				});
			}

			if (nextArrow) {
				nextArrow.addEventListener("click", () => {
					detail.go(">");
				});
			}

			if (slideCounter) {
				const updateCounter = () => {
					const currentIndex = detail.index + 1;
					const totalSlides = detail.length;
					slideCounter.textContent = `${currentIndex}/${totalSlides}`;
				};

				updateCounter();
				detail.on("move", updateCounter);
			}
		}
	}

	if (preview && detail) {
		detail.sync(preview);
	}
});
